angular.module('impactx.approval').directive('ixApprovalDivider', function() {
    return {
        scope: {
            size: '='
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/approval-divider.tmpl.html',
        link: function(scope) {
            scope.$watch('size', function(newValue) {
                scope.dividerSize = {height: '5px'};
                switch(newValue) {
                    case 1: scope.dividerSize.height = '5px'; break;
                    case 2: scope.dividerSize.height = '73px'; break;
                    case 3: scope.dividerSize.height = '141px'; break;
                    case 4: scope.dividerSize.height = '209px'; break;
                    case 5: scope.dividerSize.height = '277px'; break;
                    case 6: scope.dividerSize.height = '345px'; break;
                    case 7: scope.dividerSize.height = '413px'; break;
                    case 8: scope.dividerSize.height = '481px'; break;
                    case 9: scope.dividerSize.height = '549px'; break;
                    default: scope.dividerSize.height = '5px'
                }
            }, true);
        }
    }
});